import 'whatwg-fetch';
import { Aurelia, PLATFORM, LogManager } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import * as Bluebird from 'bluebird';
declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build
declare const VERSION: string; // The value is supplied by Webpack during the build
declare var require: any;
import { ConsoleAppender } from 'aurelia-logging-console';
import { SentryAppender, Levels } from 'aurelia-sentry';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { RewriteFrames } from '@sentry/integrations';
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-css-only/css/bootstrap-grid.min.css";

Bluebird.config({ warnings: { wForgottenReturn: false }, longStackTraces: false });
require('expose-loader?breeze!breeze-client/breeze.debug');

export function configure(aurelia: Aurelia) {

  aurelia.use
    .standardConfiguration()
    .plugin(PLATFORM.moduleName('aurelia-breeze'));
    // .plugin(PLATFORM.moduleName('aurelia-computed'))

  if (!IS_DEV_BUILD) {

    let alertCount: number = 0;

    Sentry.init({
      dsn: 'https://68dc5a7baeed492e81f53b29c14868e7@o460993.ingest.sentry.io/5462155',
      ignoreErrors: [
        'TypeError: cancelled',
        'Non-Error promise rejection captured with keys',
      ],
      release: `v-${VERSION}`,
      beforeSend: (event: Sentry.Event, hint) => {
        const urlTag: string = event.tags && event.tags.url ? event.tags.url : '';
        if (event.message && (event.message.toString().indexOf('Aurelia S') > -1 ||
          event.message.toString().indexOf('Router navigation failed') > -1 ||
          urlTag.indexOf('//localhost') > -1)) {
          return null;
        }
        if (event.message && (event.message.toString().indexOf('Non-Error promise rejection captured with keys') > -1)) {
          return null;
        }
        if (event.message && event.message.toString().indexOf('Loading chunk') > -1 &&
          event.message.toString().indexOf('failed after 3 retries') > -1 && alertCount === 0) {
          alertCount += 1;
          alert('It looks like you are using an old version of the site, which is no longer supported. Please refresh the page. If this error appears again, please clear your browser cache before refreshing.');
        }
        return event;
      },
      integrations: [new Integrations.BrowserTracing(), new RewriteFrames()],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
      maxValueLength: 1000,
    });

    // LogManager.addAppender(new SentryAppender({ minLevel: Levels.warning }));
    // LogManager.setLevel(LogManager.logLevel.warning);

  } else {

    // Sentry.init({
    //  dsn: 'https://a14734e2f34e483fb65ac3c289bec28e@o460993.ingest.sentry.io/5462176',
    //  release: `v-${VERSION}`,
    //  integrations: [new Integrations.BrowserTracing()],
    //  // Set tracesSampleRate to 1.0 to capture 100%
    //  // of transactions for performance monitoring.
    //  // We recommend adjusting this value in production
    //  tracesSampleRate: 1.0,
    // });

    LogManager.addAppender(new ConsoleAppender());
    LogManager.setLevel(LogManager.logLevel.debug);
    aurelia.use.developmentLogging();
  }

  new HttpClient().configure((config) => {
    const baseUrl = document.getElementsByTagName('base')[0].href;
    config.withBaseUrl(baseUrl);
  });

  aurelia.start().then(a => a.setRoot(PLATFORM.moduleName('app/app')));
}

export const fetchCredentials: RequestCredentials = 'include';
export const appHeaders: string[][] = ([['pragma', 'no-cache'], ['cache-control', 'no-cache']]);
